import { render, staticRenderFns } from "./authSignDocument.vue?vue&type=template&id=21a31340&"
import script from "./authSignDocument.vue?vue&type=script&lang=js&"
export * from "./authSignDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports